import { hasFeature } from '@/features/feature-flags';
import { subscriptionStore } from '@/features/subscription';
import { settingsStore } from '@/stores/settings.store';
import { userStore } from '@/stores/user.store';
import { isCapable, isWindows } from '@/utils/capabilities';

import type { SettingsMenuContext } from './settings-menu.config';

/**
 * Enabled-context for gating settings sections and search entries. Reads MobX
 * stores at call time; pass render-scoped overrides when a caller needs the
 * values tracked as hook deps
 */
export const getSettingsMenuContext = (
  overrides?: Partial<SettingsMenuContext>
): SettingsMenuContext => ({
  isCapable,
  hasFeature,
  hasMcpServerAccess: subscriptionStore.hasMcpServerAccess,
  isWindows,
  isInternalUser: userStore.isInternalUser,
  hasInternalAccess: userStore.hasInternalAccess,
  hummingbirdEnabled: settingsStore.hummingbirdEnabled,
  backendChoice: userStore.backendChoice,
  ...overrides,
});
